// extracted by mini-css-extract-plugin
export default {"Heading":"loading-card-module__Heading--xW8DO"};